import { render, staticRenderFns } from "./DeviceDetails.vue?vue&type=template&id=60515d0c"
import script from "./DeviceDetails.vue?vue&type=script&lang=js"
export * from "./DeviceDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src724620054/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60515d0c')) {
      api.createRecord('60515d0c', component.options)
    } else {
      api.reload('60515d0c', component.options)
    }
    module.hot.accept("./DeviceDetails.vue?vue&type=template&id=60515d0c", function () {
      api.rerender('60515d0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DeviceDetails.vue"
export default component.exports